const SUPABASE_URL = "https://lqcirvivlnhjeqcgailb.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxxY2lydml2bG5oamVxY2dhaWxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ1MDExNzUsImV4cCI6MjA4MDA3NzE3NX0._LfJMaUJJZQPWjXO-C9qE_RF_QeUtH_ATVQ6kX1OXuk";
const BUCKET = "pen-media";

export async function uploadMedia(file, path) {
  if (!file) throw new Error("No file selected");
  const response = await fetch(`${SUPABASE_URL}/storage/v1/object/${BUCKET}/${path}`, {
    method: "POST",
    headers: {
      apikey: SUPABASE_KEY,
      Authorization: `Bearer ${SUPABASE_KEY}`,
      "Content-Type": file.type || "application/octet-stream",
      "x-upsert": "true"
    },
    body: file
  });
  if (!response.ok) {
    let detail = "upload failed";
    try { detail = (await response.json()).message || detail; } catch (_) {}
    throw new Error(`Supabase Storage: ${detail}`);
  }
  return `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${path}`;
}
